export default __webpack_public_path__ + "static/media/57046.a2dd3f7e.jpg";